import { render, staticRenderFns } from "./buyerStore.vue?vue&type=template&id=08b7512a&"
import script from "./buyerStore.vue?vue&type=script&lang=js&"
export * from "./buyerStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports